"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLDataElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLDataElementImpl
};
